import { NotificationData } from './types';
import { createAbortableRequestPromise, ResponseData, stringify, transformArguments } from '../abortable-promise';

export class NotificationRunner {
  delay = 500;
  constructor() { }

  run(notification: NotificationData, next: () => void, retry: () => void) {
    const { url, market, sessionKey, customerKey, ...args } = notification;
    const query = stringify(transformArguments({ market, sessionKey, customerKey }));

    createAbortableRequestPromise('POST', `${url}?${query}`, JSON.stringify(args))
      .then((response: ResponseData) => next())
      .catch((err: ResponseData) => {
        if (err.status >= 400 && err.status < 500) {
          next();
        } else {
          setTimeout(retry, this.delay);
          this.delay *= 2;
        }
      });
  }
}

export const Runner = new NotificationRunner();
